<template>
  <div class="table-tab">
    <div class="table-tab__container">
      <table class="table-tab__block table " style="width: 1100px">
        <thead class="table-tab__thead">
        <tr class="">
          <th class="table-tab__width-90 table-tab__th--row">№</th>
          <th>{{$t('form.lot.specs.nomenclature')}}</th>
          <th>{{$t('form.lot.specs.quantity')}}</th>
          <th>{{$t('form.lot.specs.unit')}}</th>
          <th>{{$t('form.lot.specs.price-per-unit')}}</th>
          <th>{{$t('form.lot.specs.total-price')}}</th>
          <th>{{$t('form.lot.specs.bid-currency')}}</th>
          <th>{{$t('form.lot.specs.contract-currency')}}</th>
          <th class="table-tab__width-180"></th>
        </tr>
        </thead>
        <tbody class="table-tab__tbody">
        <template v-for="(item, i) in specs">
          <tr class="table-tab__tr-border">
            <!-- Открытие таба table-tab__btn-open-->
            <th class="table-tab__th table-tab__th--row table-tab__btn-open">
              <img src="@/assets/img/static/arrow-up.png" alt="">
              {{i + 1}}
            </th>

            <td>{{item.catalog.name}}</td>
            <td>{{item.percent ? $options.filters.percent(item.count) : item.count}}</td>
            <td>{{item.percent ? '% процент': item.okeiName || 'из справочника'}}</td>
            <td class="text-nowrap">{{item.price | price}}</td>
            <td class="text-nowrap">{{(item.price * item.count) | price}}</td>
            <td v-t="item.currency.label"></td>
            <td v-t="item.currencyContract.label"></td>

            <td class="table-tab__width-180"></td>
          </tr>

          <template v-for="(part, partId) in item.parts">
            <tr class="table-tab__open" v-if="item.parts[partId] > 0">
              <th class="table-tab__width-90 table-tab__th--row "></th>
              <td class="">
                <label class="a-checkbox__label ">
                  <input class="a-checkbox__input" type="checkbox" disabled :checked="item.parts[partId] > 0">
                  <span class="a-checkbox__icon"><i></i></span>
                  <span class="a-checkbox__text">{{$t('form.lot.parts.part-number', {id: partId + 1})}}</span>
                </label>
              </td>

              <td v-if="item.percent">{{item.parts[partId] | percent}}</td>
              <td v-else>{{item.parts[partId]}}</td>

              <td >{{item.percent ? '%' : item.okeiName}}</td>

              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="table-tab__width-180"></td>
            </tr>
          </template>
        </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      lot: Object
    },

    computed: {
      specs() {
        return this.lot.specs;
      }
    }
  }
</script>

<style scoped>

</style>
